import { IEditPincodePayload, IPincodeCreate, IPincodeListSearch, IPincodeSearch } from "../../../../types/master/pincodeInterface";
import api from "../../../../lib/api";

export const getPincodeByPincodeApi = async (data: IPincodeSearch) => {
  return await api.get(`pincode/${data.pincode}`, {
    signal: data.signal,
  });
};

export const createPincodeApi = async (data: IPincodeCreate) => {
  return await api.post(`/pincode`, data);
};

export const getPincodeListApi = async (data: IPincodeListSearch) => {
  return await api.get(`/pincode/${data.page}/${data?.pageLimit ?? 10}`, {
    params: {
      search: data?.search ?? "",
      branch_id: data?.branch_id ?? "",
      district_id: data?.district_id ?? "",
      area_code_id: data?.area_code_id ?? "",
      state_id: data?.state_id ?? "",
      zone_id: data?.zone_id ?? "",
      pricing_zone_id: data?.pricing_zone_id ?? "",
    },
  });
};

export const editPincodeByPincodeApi = async (payload: IEditPincodePayload) => {
  return await api.put(`/pincode/${payload.pincode}`, payload.data);
};

export const getPincodeExport = (params: any) => {
  return api.get(`/pincode/export-pincode`, {
    params,
    responseType: "blob",
  });
};

interface IPincodeServiceabilityPayload {
  origin_pincode: string;
  destination_pincode: string;
}

export const getPincodeServiceabilityApi = async (params: IPincodeServiceabilityPayload) => {
  return await api.get("/pincode/public-pincode-serviceability", {
    params,
  });
};